export default __webpack_public_path__ + "images/icons.2d6027fca458743e127c85a7f6fc3857.svg";